import React, { Component } from 'react';
import './RoadClosureDialog.css';

export default class RoadClosureDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 1,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange (event, index, value) {
    console.log(event, index, value);
    this.setState({value});
  }

  render() {
    return (
      <div className="dropdown-container">
        <span style={{color: "#ff0000"}}>**Road closure times listed here are approximate and may fluctuate depending on the decisions of the public safety agencies which oversee each area.**<br /><br /></span>
        <p><strong>Monday, April 18, 2016:</strong></p>
        <p>CLOSURES FOR VEHICLE TRAFFIC - RACE COURSE</p>
        <p>Hopkinton: <span data-term="goog_551494807">7:00 a.m. &ndash; 1:30 p.m.</span></p>
        <p>Ashland: <span data-term="goog_551494808">7:15 a.m. &ndash; 1:45 p.m.</span></p>
        <p>Framingham <span data-term="goog_551494809">8:30 a.m. &ndash;  2:15 p.m.</span></p>
        <p>Natick: <span data-term="goog_551494810">8:30 a.m. &ndash; 2:45 p.m. </span>&nbsp;</p>
        <p>Wellesley: <span data-term="goog_551494811">8:30 a.m. &ndash; 3:15 p.m.</span></p>
        <p>Newton: <span data-term="goog_551494812">8:45 a.m. &ndash; 4:15 p.m.</span>&nbsp;</p>
        <p>Brookline: <span data-term="goog_551494813">9:15 a.m. &ndash; 5:15 p.m.</span></p>
        <p>Boston: Variable - <span data-term="goog_551494814">6:30 p.m.</span></p>
        <p>- From <span data-term="goog_551494815">5:00 a.m.</span>: streets in the vicinity of Boston Common (detail below)</p>
        <p>- From <span data-term="goog_551494816">6:30 a.m.</span>: streets in the vicinity of Copley Square (detail below)</p>
        <p>- From <span data-term="goog_551494817">8:00 a.m.</span>: all streets east of Massachusetts Avenue (as well as Massachusetts Turnpike, Exit 22.) (detail below)</p>
        <p>- From <span data-term="goog_551494818">8:00 a.m.</span> all streets west of Mass Ave., in the Kenmore Square, Audubon Circle area (detail below)</p>
        <p>- From <span data-term="goog_551494819">8:30 a.m.</span>: all streets in the Brighton area leading into the route (detail below)</p>
        <br />
        <p><strong>Boston Common Area - <span data-term="goog_551494820">5:00 a.m.</span></strong></p>
        <p>- Tremont street: from Court Street to Boylston Street</p>
        <p>- Avery street: from Washington Street to Tremont Street</p>
        <p>- West street: from Washington Street to Tremont Street</p>
        <p>- Temple place: from Washington Street to Tremont Street</p>
        <p>- Winter street: from Washington Street to Tremont Street</p>
        <p>- Park street: from Beacon Street to Tremont Street</p>
        <p>- Bromfield street: from Washington Street to Tremont Street</p>
        <p>- Beacon street: from Somerset Street to Tremont Street</p>
        <p>- Cambridge street (inbound): from New Sudbury Street to Tremont Street</p>
        <p>&nbsp;</p>
        <p><strong>Back Bay Area - <span data-term="goog_551494821">6:30 a.m.</span></strong></p>
        <p>- Boylston St.: from Hereford to Arlington St.</p>
        <p>&nbsp;</p>
        <p><strong>Back Bay Area - <span data-term="goog_551494822">8:00 a.m.</span></strong></p>
        <p>- Berkeley Street: from St. James Avenue to Newbury Street.</p>
        <p>- Clarendon Street: from St. James Avenue to Newbury Street.</p>
        <p>- Dartmouth Street: from St. James Avenue to Newbury Street.</p>
        <p>- Exeter Street: from Newbury Street to Huntington Avenue.</p>
        <p>- Ring road: from Huntington Avenue to Boylston Street.</p>
        <p>- Fairfield Street: from Newbury Street to Boylston Street.</p>
        <p>- Gloucester Street: from Newbury Street to Boylston Street.</p>
        <p>- Providence Street: from Arlington Street to Berkeley Street. (BEMS vehicles only)</p>
        <p>- Trinity Place: from St. James Avenue to Massachusetts Turnpike on ramp.</p>
        <p>&nbsp;</p>
        <p><strong>Back Bay Area - <span data-term="goog_551494823">8:00 a.m.</span></strong></p>
        <p>- Boylston St.: from Massachusetts Avenue to Arlington Street.</p>
        <p>- Newbury Street: from Arlington Street to Charles Gate East.</p>
        <p>- St. James Avenue: from Arlington Street to Dartmouth Street.</p>
        <p>- Huntington Avenue (outbound): from Dartmouth Street to Belvidere Street.</p>
        <p>- Stuart Street: from Arlington Street to Dartmouth Street.</p>
        <p>- Blagden Street: from Huntington Avenue to Exeter Street</p>
        <p>- Berkeley Street: from Columbus Avenue to Newbury Street.</p>
        <p>- Clarendon Street: from Commonwealth Avenue to Columbus Avenue.</p>
        <p>- Dartmouth Street: from Commonwealth Avenue to Columbus Avenue.</p>
        <p>- Exeter Street: from Commonwealth Avenue to Huntington Avenue.</p>
        <p>- Fairfield Street: from Commonwealth Avenue to Boylston Street.</p>
        <p>- Gloucester Street: from Commonwealth Avenue to Boylston Street.</p>
        <p>- Hereford: from Commonwealth Avenue to Boylston Street.</p>
        <p>- Dalton Street: from Belvidere Street to Boylston Street.</p>
        <p>- Belvidere Street: from Huntington Avenue to Dalton Street.</p>
        <p>&nbsp;</p>
        <p><strong>Kenmore Square Area - <span data-term="goog_551494824">8:00 a.m.</span></strong></p>
        <p>- Beacon Street: from Park Drive to Commonwealth Avenue</p>
        <p>- Brookline Avenue: from Lansdowne Street to Commonwealth Avenue</p>
        <p>- Newbury street extension: from Brookline Avenue to Charlesgate west</p>
        <p>- Commonwealth Avenue (inbound): from BU Bridge to Gloucester Street</p>
        <p>- Commonwealth Avenue (outbound): from Hereford Street to Deerfield Street</p>
        <p>- Kenmore Street: from Newbury Street Ext. to Comm. Ave. outbound</p>
        <p>- Raleigh Street: from Beacon Street Ext. to Comm. Ave. outbound</p>
        <p>&nbsp;</p>
        <p><strong>Brighton/Cleveland Circle Area - <span data-term="goog_551494825">9:00 a.m.</span></strong></p>
        <p>Commonwealth Avenue:</p>
        <p>- From Newton City Line, (Lake Street), to Chestnut Hill Avenue.</p>
        <p>Beacon Street:</p>
        <p>- From Chestnut Hill Avenue to Brookline town line (Cleveland Circle). The entire length of</p>
        <p>Beacon Street in Brookline is closed since it is part of the race's route.</p>
        <p>Chestnut Hill Avenue:</p>
        <p>- From Commonwealth Avenue to Brookline town line, (Ayr Road).</p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/marathon/RoadClosureDialog.jsx